import React, { useContext, useState, useEffect } from 'react';
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from '../../Context/ConfigContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { SubmitButton } from '../../Components/InputElements';
import { currentDateAndTime, decryptData, parseQueryString } from '../../Constants/constants';
import ViewOnlyHeader from '../../Layout/ViewOnlyHeader';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const OfferLetter = () => {
    const query = useQuery();
    const encryptedData = query.get("data");

    // const corrected = encryptedData.replace(/ /g, '+');
    // console.log('Decrypted Data:', corrected);

  // Extracted Mobile Number
    const [companyId, setCompanyId] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const { apiURL, apiHeaderFile, apiHeaderJSON } = useContext(ConfigContext);
    const [pdfUrlRows, setPdfUrlRows] = useState([]);
    const [companyInfo, setCompanyInfo] = useState({});
    const [acceptRejectBtn, setAcceptRejectBtn] = useState(false);
    const [isPage404, setIsPage404] = useState(false);
    const [message, setMessage] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const navigate = useNavigate();

    console.log('encryptedData Data:', encryptedData); // Full encryptedData query string


    const getList = () => {
        
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Home/GetLetterData`, {
                params: {
                    company_id: companyId,
                    guest_employee_mobile_number: mobileNumber,
                    date: currentDateAndTime(),
                },
                headers,
            })
            .then((response) => {
                var data = response.data;
                console.log(data);
                if (response.data.success === true) {
                    setPdfUrlRows(data?.letter_data);
                    setCompanyInfo(data?.company_info[0]);
                    setAcceptRejectBtn(data?.button_hide);
                    setIsPage404(false);
                    setMessage(false);
                    setLoading(false);
                } else {
                    if(data?.message === "This link is expired."){
                        setIsPage404("2");
                    }
                    else{
                        setIsPage404("1");
                        setMessage(data?.message);
                    }
                    setLoading(false);
                }
            }).catch((error)=>{
                setIsPage404("1");
                setMessage("Opps...! Something went wrong !!");
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: "Opps...! Something went wrong !!",
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
                setLoading(false);
            });
    };
    const getDecryptedData = () => {
        const headers = apiHeaderJSON;
        const fromData={
            encryptedData:encryptedData
        }
        axios
            .post(`${apiURL}User/DecryptData`,fromData, {headers})
            .then((response) => {
                var data = response.data;
                console.log('DecryptData',data);
                if (response.data.success === true) {
                    let temp= parseQueryString(data?.decryptedData)
                   setMobileNumber(temp?.mo_n);
                   setCompanyId(temp?.c_id);
                } else {
                    setIsPage404("1");
                    setMessage(data?.message);
                    setLoading(false);
                }
            }).catch((error)=>{
                setIsPage404("1");
                    setMessage("Opps...! Something went wrong !!");
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: "Opps...! Something went wrong !!",
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                })
                setLoading(false);
            });
    };
    useEffect(()=>{
        if(encryptedData){
            setLoading(true);
            getDecryptedData();
            setIsPage404(false);
        }
    },[])
    useEffect(() => {
        if (companyId && mobileNumber) {
            setLoading(true);
            getList();
            setIsPage404(false);
        }
        else if (!encryptedData) {
            setLoading(false);
            setIsPage404("1");
        }

    }, [companyId , mobileNumber])

    const handleAccept = () => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to accept this offer?`,
            icon: 'warning',
            // reverseButtons: true,
            input: 'text',
            inputPlaceholder: 'Remark (Optional)',
            showCancelButton: true,
            confirmButtonText: 'Yes, Accept!',
            cancelButtonText: 'No!',
            // inputValidator: (value) => {
            //     if (!value) {
            //         return 'Remark cannot be empty';
            //     }
            // },
        }).then((result) => {
            if (result.isConfirmed) {
                setLoadingSubmit("1");
                let data = {
                    request_type: 1,
                    remark: result?.value || "",
                    date: currentDateAndTime()
                }
                const headers = apiHeaderJSON;
                console.log(data);
                axios
                    .post(`${apiURL}Home/AcceptRejectOfferLetter`, data, {
                        params: {
                            company_id: companyId,
                            guest_employee_mobile_number: mobileNumber
                        },
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleAcceopt ~ response =======>>>", response);
                        if (success === true) {
                            setAcceptRejectBtn(true);
                            Swal.fire({
                                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'
                                    }</strong>`,
                                text: response.data.message,
                                icon: response.data.success === true ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false
                            })
                        } else {
                            Swal.fire({
                                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'
                                    }</strong>`,
                                text: response.data.message,
                                icon: response.data.success === true ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false
                            })
                        }
                        setLoadingSubmit(false);
                    })
                    .catch((error)=>{
                        console.log("AcceptRejectOfferLetter => ERROR:",error);
                        setLoadingSubmit(false);
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }
    const handleReject = () => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to reject this offer?`,
            icon: 'warning',
            // reverseButtons: true,
            input: 'text',
            inputPlaceholder: 'Remark*',
            showCancelButton: true,
            confirmButtonText: 'Yes, Reject!',
            cancelButtonText: 'No!',
            inputValidator: (value) => {
                if (!value) {
                    return 'Remark cannot be empty';
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                setLoadingSubmit("2");
                let data = {
                    request_type: 2,
                    remark: result?.value,
                    date: currentDateAndTime()
                }
                const headers = apiHeaderJSON;
                console.log(data);
                axios
                    .post(`${apiURL}Home/AcceptRejectOfferLetter`, data, {
                        params: {
                            company_id: companyId,
                            guest_employee_mobile_number: mobileNumber
                        },
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleAcceopt ~ response =======>>>", response);
                        if (success === true) {
                            setAcceptRejectBtn(true);
                            Swal.fire({
                                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'
                                    }</strong>`,
                                text: response.data.message,
                                icon: response.data.success === true ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false
                            })
                        } else {
                            Swal.fire({
                                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'
                                    }</strong>`,
                                text: response.data.message,
                                icon: response.data.success === true ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false
                            })
                        }
                        setLoadingSubmit(false);
                    })
                    .catch((error)=>{
                        console.log("AcceptRejectOfferLetter => ERROR:",error);
                        setLoadingSubmit(false);
                    });;
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }

    return (
        <>
            {!isPage404?
            !acceptRejectBtn?
                !loading?
                <div class="main-content" >
                    <ViewOnlyHeader url={companyInfo?.logo_url} name={companyInfo?.company_name} />
                    <div class="">
                        <div className="container-fluid">
                            <br />
                            <h4 className='font-semibold '>Offer Letter</h4>
                            <div className="lg-card">
                                <div className="card-body">
                                    <div className='md-px-3 py-3 md-mx-3'>
                                        {/* <div className=' px-1  bg-white rounded-2'>
                                            {companyInfo?.logo_url ?
                                                <img style={{ maxWidth: 150, width: '100%' }} src={companyInfo?.logo_url} alt="Company Logo" /> :
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f2f2f2', width: 50, height: 50, borderRadius: 10 }}>
                                                    <img style={{ maxWidth: 150, width: '100%' }} src="/img/placeholder-logo.png" alt="Company Logo" />
                                                </div>
                                            }
                                            <h3 className=' md-d-flex'>Welcome to, <h3 style={{ color: "#0668D5" }}>{companyInfo?.company_name}</h3> </h3>
                                        </div> */}
                                        {/* {
                                pdfUrlRows?.map((val)=>{
                                    return (
                                        <div className=' mb-4 m-auto p-3 rounded-2 grayBlurShadow'  style={{ width: "70%",}}>
                                            <h3 className=' text-center'>{val?.company_letter_title}</h3>
                                            <div className=' m-auto rounded-3 overflow-hidden' style={{ width: "100%", height: "600px", border: "1px solid #ccc" }}>
                                                <iframe
                                                    src={`https://docs.google.com/gview?url=${val?.letter_url}&embedded=true`}
                                                    title="File Viewer"
                                                    style={{ width: "100%", height: "100%" }}
                                                    frameBorder="0"
                                                >
                                                    This browser does not support embedded files.
                                                </iframe>
                                                 
                                            </div>
                                        </div>
                                    )
                                })
                            } */}
                                        {
                                            pdfUrlRows?.map((val) => {
                                                return (
                                                    <div
                                                        className="mb-4 m-auto p-3 bg-white offer-iframe rounded-2 offer-letter-box grayBlurShadow"
                                                        // style={{ width: "70%" }}
                                                        key={val?.letter_url}
                                                    >
                                                        <h3 className="text-center">{val?.company_letter_title}</h3>
                                                        <div
                                                            className="m-auto rounded-3 overflow-hidden"
                                                            style={{
                                                                width: "100%",
                                                                height: "90%",
                                                                border: "1px solid #ccc",
                                                            }}
                                                        >
                                                            <iframe
                                                                src={val?.letter_url}
                                                                title="PDF Viewer"
                                                                style={{ width: "100%", height: "100%" }}
                                                                frameBorder="0"
                                                            >
                                                                This browser does not support embedded files.
                                                            </iframe>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                        {/* <div
                                style={{
                                    width: "100%",
                                    height: "600px", // Define the container height
                                    border: "1px solid #ccc",
                                    overflowY: "scroll", // Enable scrolling for vertical overflow
                                    display: "block", // Avoid unnecessary flexbox alignment issues
                                }}
                                >
                                <div className=' w-75 m-auto' >
                                    <img
                                        src="http://143.110.190.50:4000/storage/company_4/company_letterheads/Header%201%20letterhead_2024-11-12_972%20.JPG"
                                        alt="File Viewer"
                                        style={{
                                        width: "100%", // Full width
                                        height: "auto", // Maintain aspect ratio
                                        objectFit: "contain", // Contain the image within bounds
                                        display: "block", // Ensure no inline spacing affects layout
                                        marginBottom: "10px", // Space between images
                                        }}
                                    />
                                </div>
                            </div> */}


                                        <div style={{ marginTop: '30px', }} className='offer-letter-box m-auto'>
                                            {/* <button
                                                disabled={acceptRejectBtn}
                                                style={{ marginRight: "10px" }}
                                                onClick={handleAccept}
                                                className={`btn btn-success btn-label waves-effect waves-light float-right`}
                                            >
                                                <i
                                                    className={`ri-mail-check-line label-icon align-middle fs-16 ms-2`}
                                                />
                                                {'Accept'}
                                            </button> */}
                                            <SubmitButton onClick={()=>{
                                            if(!loadingSubmit){handleAccept();}}}
                                            loading={loadingSubmit==='1'}
                                            disabled={loadingSubmit || acceptRejectBtn}
                                            buttonName={"Accept"} loadingMessage='Loading' type='success' icon='ri-mail-check-line' />
                                            <span className=' me-3' />
                                            {/* <button
                                                disabled={acceptRejectBtn}
                                                onClick={handleReject}
                                                className={`btn btn-danger btn-label waves-effect  waves-light float-right`}
                                            >
                                                <i
                                                    className={`ri-mail-close-line label-icon align-middle fs-16 ms-2`}
                                                />
                                                {'Reject'}
                                            </button> */}
                                            <SubmitButton onClick={()=>{
                                            if(!loadingSubmit){handleReject();}}}
                                            loading={loadingSubmit==='2'}
                                            disabled={loadingSubmit || acceptRejectBtn}
                                            buttonName={"Reject"} loadingMessage='Loading' type='danger' icon='ri-mail-close-line' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>:
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>:
                <div>
                <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                  {/* auth-page content */}
                  <div className="auth-page-content overflow-hidden p-0">
                    <div className="container">
                      <div className="row justify-content-center">
                        <div className="col-xl-7 col-lg-8">
                          <div className="text-center">
                            <img
                            style={{ width:"19%"}}
                              src="assets/images/check.png"
                              alt="check yes img"
                              className="img-fluid"
                            />
                            <div className="mt-3">
                              <h3 style={{color:"#4CD24C"}} className="  fw-bolder">
                                Thank You!
                              </h3>
                              <h3 className="">
                                Your response has been saved successfully.
                              </h3>
                              <p className="text-muted mb-4">
                                We'll connect you when discussion is made.
                              </p>
                              {/* <NavLink to={'/'} className="btn btn-success"><i className="mdi mdi-home me-1" />Back to home</NavLink> */}
                            </div>
                          </div>
                        </div>
                        {/* end col */}
                      </div>
                      {/* end row */}
                    </div>
                    {/* end container */}
                  </div>
                  {/* end auth-page content */}
                </div>
              </div> :
                isPage404==="2"?
                <div>
                    <div className="auth-page-wrapper bg-white py-1 d-flex justify-content-center align-items-center min-vh-100">
                        {/* auth-page content */}
                        <div className="auth-page-content overflow-hidden p-0">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-xl-7 col-lg-8">
                                        <div className="text-center">
                                            <img src="assets/images/link_expired.png" alt="error img" className="img-fluid" />
                                            <div className="mt-3">
                                                <h3 className="text-uppercase">❌ The link you followed has expired.</h3>
                                                {/* <p className="text-muted mb-4"></p> */}
                                            </div>
                                        </div>
                                    </div>{/* end col */}
                                </div>
                                {/* end row */}
                            </div>
                            {/* end container */}
                        </div>
                        {/* end auth-page content */}
                    </div>

                </div>:
                <div>
                <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                    {/* auth-page content */}
                    <div className="auth-page-content overflow-hidden p-0">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xl-7 col-lg-8">
                                    <div className="text-center">
                                        <img src="assets/images/error400-cover.png" alt="error img" className="img-fluid" />
                                        <div className="mt-3">
                                            <h3 className="text-uppercase">{ message || `Sorry, Page not Found 😭` }</h3>
                                            <p className="text-muted mb-4">The page you are looking for not available!</p>
                                            {/* <NavLink to={'/'} className="btn btn-success"><i className="mdi mdi-home me-1" />Back to home</NavLink> */}
                                        </div>
                                    </div>
                                </div>{/* end col */}
                            </div>
                            {/* end row */}
                        </div>
                        {/* end container */}
                    </div>
                    {/* end auth-page content */}
                </div>
                </div>
            }
        </>
    );
}

export default OfferLetter;
